<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero2" id="mud2">
            <div>
                <img src="/images/brand-bgs/brand-logo-bg.png" alt="background">
                <img src="/images/brand-logos/mud-logo-trimmed.png" alt="mud logo">
            </div>
        </div>

        <div class="brand-content">
            <div>
                <p>
                    Mud® gloves are designed specifically with you, the gardener, in mind.  
                    We strive to build products that keep your hands in comfortable, functional designs at an affordable cost, that are unique to your own personal style and perfect for any muddy task.
                </p>
                <p>  
                    We believe that genuine quality, consistent fit, fair price points, and sustainability matter as we create our gardening products.  
                    We are confident that if these attributes matter to you, too, that you will be able to find what you need in our collection.  
                    The Mud® brand is backed by PIP Industrial Products, which has been dominating the safety and protective gear market since 1984.  
                    We not only care about the creativity that goes into our product design, but also stand by the materials and functionality features that work to protect you when you wear them!
                </p>

                <a href="https://www.mudglove.com/" class="btn-round-black" target="_blank">Mudglove.com</a>
            </div>
        </div>

        <div class="socialspace" style="background-color: #4c3c17;">
            <div>
                <div>
                    <h4>Contact Us</h4>
                    <div class="contact-container">            
                        <div>
                            <a href="mailto:info@mudglove.com">
                                <font-awesome-icon :icon="['fas', 'envelope']" />
                            </a>                 
                            <a href="mailto:info@mudglove.com">info@mudglove.com</a>
                        </div>
                        <div>
                            <a href="tel:800-475-0567">
                                <font-awesome-icon :icon="['fas', 'phone']" />
                            </a>
                            <a href="tel:800-475-0567">(800) 475-0567</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Buy Now</h4>
                    <div>
                        <a href="https://www.mudglove.com/shop-gloves/" target="_blank" aria-label='Link opens in new window (mudglove.com/shop-gloves/)'>
                            <font-awesome-icon :icon="['fas', 'cart-shopping']" />
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
    }
};
</script>
